/**
 * Gating Components Module
 *
 * Tier-gating components for blur teaser paywall pattern.
 * Provides platform-specific implementations (web/native).
 *
 * @example
 * import { GatedSection } from '@/components/gating';
 *
 * <GatedSection
 *   requiredTier="drama_plus"
 *   contentType="patterns"
 *   screen="HistoryScreen"
 *   onUpgrade={() => navigation.navigate('Upgrade')}
 * >
 *   <PatternCards patterns={patterns} />
 * </GatedSection>
 */

// Main component (Metro auto-resolves .web.tsx / .native.tsx)
export { default as GatedSection } from './GatedSection';

// Manifest-backed declarative gate (C3B — NocoDB #4085).
// Use TierGate when the question is "should this surface mount at all?".
// Use GatedSection when you want the blurred-teaser + upgrade CTA pattern.
export { TierGate, type TierGateProps } from './TierGate';

// Supporting components
export { UpgradePrompt } from './UpgradePrompt';

// Hooks
export { useGatedAnalytics } from './useGatedAnalytics';

// Utilities
export { hasTierAccess } from './utils';

// Types
export * from './types';
